import React, { useCallback } from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import InputField from '@commonComponents/formComponents/CustomInputField'
import DeleteIcon from '@commonComponents/deleteIcon'

const PackageForm = (props) => {
    const {
        dataSource: {
            id,
            quantity,
            type,
            shippingMarks,
        },
        packageTypeList = [],
        translate,
        onChange,
        onSelect,
        onBlur,
        deleteData,
        tableName,
        pckgIdx,
        packagesListValidation,
        disabled,
        copyDocument,
        isPackageDocDisabled,
        markedDeleted
    } = props

    const onChangeHandler=useCallback(({target:{value,name}})=>onChange(id,tableName,{[name]:value}),[tableName,id,onChange])
    const onDropDownChange=useCallback((e, {value,name})=>{
        if(packagesListValidation) packagesListValidation(pckgIdx,name,value,type,quantity,shippingMarks)
        onSelect(id,tableName,{[name]:value,id})
    
    },
    [tableName,id,onSelect])
    const onBlurHandler=useCallback(({target:{value,name}})=>{
        if(packagesListValidation) packagesListValidation(pckgIdx,name,value,type,'','')
        onBlur(tableName,{[name]:value,id})
    },
    [tableName,id,onBlur])

    return (<div className="formContainer">
         <div className="actionbtns">
        {copyDocument && copyDocument(translate)}
      </div> 
        <Grid.Row>
            <Grid.Column>
                <DropDown
                    id={`type-${id}`}
                    label="PKG_TYPE"
                    className='field-bg dropdown100'
                    boxNumber='6/9'
                    labelClass='text-none'
                    isDisabled={(isPackageDocDisabled||disabled||null)}
                    isLabel={true}
                    data={packageTypeList}
                    clearable
                    value={type}
                    text={type}
                    name='type'
                    onChange={onDropDownChange}
                />
            </Grid.Column>
            <Grid.Column>
                <InputField
                    isLabel={false}
                    id={`quantity-${id}`}
                    type='number'
                    label="PKG_QTY"
                    boxNumber='6/10'
                    isDisabled={(isPackageDocDisabled||disabled||null)}
                    value={quantity}
                    name='quantity'
                    className='field-bg'
                    clearInput={false}
                    onChange={onChangeHandler}
                    onBlur={onBlurHandler}
                />
            </Grid.Column>
            <Grid.Column width='2'>
                <InputField
                    isLabel={false}
                    id={`shippingMarks-${id}`}
                    type='text'
                    label="SHIPPING_MARKS"
                    boxNumber='6/11'
                    isDisabled={(isPackageDocDisabled||disabled||null)}
                    value={shippingMarks}
                    name='shippingMarks'
                    className='field-bg'
                    clearInput={false}
                    onChange={onChangeHandler}
                    onBlur={onBlurHandler}
                />
            </Grid.Column>
        </Grid.Row>
        <div className="actionbtns">
            {markedDeleted?markedDeleted({id, tableName}):
            <DeleteIcon onClick={() => deleteData(id, tableName)} isDisabled={disabled} />}
        </div>
    </div>
    )
}

export default PackageForm